/**
 * cl-list-item-secondary-action
 *
 * An action element positioned right of cl-list-item-text
 */

import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ClListItemSecondaryAction extends Vue {}
